module.exports = __webpack_public_path__ + "media/images/emblems/GX-VD-Villars-le-Comte-ccf1436a1aeb04c2481add993183117f.png";